/* eslint-disable jsx-a11y/anchor-is-valid */
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Offerlayout from "./components/Offerlayout";
import Top from "./components/Top";
import MobileMenu from "./components/MobileMenu";
import PopupSearchBox from "./components/PopupSearchBox";
import SideMenu from "./components/SideMenu";
import CartSidebar from "./components/CartSidebar";
import Error from "./Error";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Properties from "./pages/Properties/Properties";
import PropertiesDetails from "./pages/PropertyDetails/PropertiesDetails";
import Gallery from "./pages/Gallery/Gallery";
import Blogs from "./pages/Blogs/Blogs";
import BlogDetails from "./pages/BlogDetails/BlogDetails";
import Contact from "./pages/Contact/Contact";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const [isCartSidebarOpen, setIsCartSidebarOpen] = useState(false);
  const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleSideMenu = () => {
    setIsSideMenuOpen(!isSideMenuOpen);
  };

  const toggleCartSidebar = () => {
    setIsCartSidebarOpen(!isCartSidebarOpen);
  };

  const toggleSearchBox = () => {
    setIsSearchBoxOpen(!isSearchBoxOpen);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Top />
        <>
          <MobileMenu
            isOpen={isMobileMenuOpen}
            toggleMobileMenu={toggleMobileMenu}
          />

          <PopupSearchBox
            isOpen={isSearchBoxOpen}
            toggleSearchBox={toggleSearchBox}
          />

          <Header
            toggleMobileMenu={toggleMobileMenu}
            toggleSideMenu={toggleSideMenu}
            toggleCartSidebar={toggleCartSidebar}
            toggleSearchBox={toggleSearchBox}
          />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/properties" element={<Properties />} />
            <Route
              path="/properties/property-details/:id"
              element={<PropertiesDetails />}
            />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/blog-details/:id" element={<BlogDetails />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="*" element={<Error />} />
          </Routes>

          <Offerlayout />
          <Footer />

          <SideMenu isOpen={isSideMenuOpen} toggleSideMenu={toggleSideMenu} />

          <CartSidebar
            isOpen={isCartSidebarOpen}
            toggleCartSidebar={toggleCartSidebar}
          />

          <a href="#" className="scrollToTop scroll-btn">
            <i className="far fa-arrow-up"></i>
          </a>

          <WhatsAppButton />
        </>
      </BrowserRouter>
    </div>
  );
}

export default App;
